import axios from "axios";
import signMd5Utils from "./signMd5Utils";
// import qs from "qs";

// const baseUrl = "http://10.0.0.129:8080"; // 测试环境
// const baseUrl = "https://www.ersanli.co/mars"; // 测试环境
const baseUrl = "https://aigc.ersanli.cn/mars"; // 测试环境
// const baseUrl = "/api"; // 测试环境

// 微信登录
export const wxLoginWithCode = (code) => {
  return axios.get(
    `${baseUrl}/user/getUserInfo?code=${code}&art=assistance202309`
  );
};

//顶部工具列表
export const getTagList = (size) => {
  return axios.get(`${baseUrl}/aigc/tagList?size=${size}`);
};

//工具栏列表
export const getToolsList = (size) => {
  return axios.get(`${baseUrl}/aigc/toolList?size=${size}`);
};

//应用广场列表
export const getAppList = (tag, size) => {
  return axios.get(`${baseUrl}/aigc/toolList?tag=${tag}&size=${size}`);
};

//搜索应用
export const searchAppList = (keyword) => {
  return axios.get(`${baseUrl}/aigc/toolList?keyword=${keyword}`);
};

//热点新闻
export const getHotNewsList = () => {
  return axios.get(`${baseUrl}/aigc/hotNews`);
};

//热点新闻更多
export const getHotNewsMoreList = (name, pageNo, pageSize) => {
  return axios.get(
    `${baseUrl}/aigc/hotNewsMore?name=${name}&pageNo=${pageNo}&pageSize=${pageSize}`
  );
};

//资讯分类
export const getCategoriesList = (more) => {
  return axios.get(`${baseUrl}/aigc/categoriesList?more=${more}`);
};

//资讯列表(更多)
export const getArticleList = (categoriesId, pageNo, pageSize, order) => {
  return axios.get(
    `${baseUrl}/aigc/articleList?categoriesId=${categoriesId}&pageNo=${pageNo}&pageSize=${pageSize}&order=${order}`
  );
};

//文章搜索
export const searchArticleList = (pageNo, keyword) => {
  return axios.get(
    `${baseUrl}/aigc/searchArticle?keyword=${keyword}&pageNo=${pageNo}`
  );
};
//文章点击统计
export const commitArticleHits = (id) => {
  return axios.get(`${baseUrl}/aigc/articleHits?id=${id}`);
};

//资讯详情 articleDetail
export const getArticleDetail = (articleId) => {
  return axios.get(`${baseUrl}/aigc/articleDetail?id=${articleId}`);
};

//提交报名信息
// export const submitData = (data) => {
//   axios.defaults.headers.post["Content-Type"] = "application/json";
//   return axios.post(
//     `${baseUrl}/assistance/addInfo
//   `,
//     data
//   );
// };

// 配置微信分享
export const configWxData = (url) => {
  let data = new FormData();
  data.append("url", url);
  axios.defaults.headers.post["Content-Type"] =
    "application/x-www-form-urlencoded";
  return axios.post("https://api.ersanli.cn/kilos/ajax/wechat", data);
};

// axios 配置
axios.defaults.timeout = 100000;
axios.defaults.headers.post["Content-Type"] = "application/json";
axios.defaults.headers["Access-Control-Allow-Origin"] = "*";
axios.defaults.headers["Access-Control-Allow-Headers"] =
  "Origin,Content-Type,Accept,token,X-Requested-With";

// import qs from "qs";

// 请求的拦截器
axios.interceptors.request.use(
  function (config) {
    // 判断请求的类型
    // 如果是post请求就把默认参数拼到data里面
    // 如果是get请求就拼到params里面
    let user = JSON.parse(localStorage.getItem("user"));
    if (config.method === "post") {
      // if (user) {
      //   let userid = user.id;
      //   let data = qs.parse(config.data);
      //   config.data = qs.stringify({
      //     userid: userid,
      //     ...data,
      //   });
      // }
    } else if (config.method === "get") {
      if (user) {
        let userid = user.id;
        config.params = {
          userid: userid,
          ...config.params,
        };
      }
      let sign = signMd5Utils.getSign(config.url, config.params);
      config.headers = {
        "X-Sign": sign,
        "X-TIMESTAMP": signMd5Utils.getTimestamp(),
        ...config.headers,
      };
    }

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// axios.interceptors.response.use(
//   (response) => {
//     // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
//     // 否则的话抛出错误
//     if (response.status === 200) {
//       // if (response.data.code === 401) {
//       //   window.localStorage.removeItem('token')
//       //   Router.push({name: 'login'})
//       //   return false
//       // }
//       return Promise.resolve(response);
//     } else {
//       return Promise.reject(response);
//     }
//   },
//   // 服务器状态码不是2开头的的情况
//   // 这里可以跟你们的后台开发人员协商好统一的错误状态码
//   // 然后根据返回的状态码进行一些操作，例如登录过期提示，错误提示等等
//   // 下面列举几个常见的操作，其他需求可自行扩展
//   (error) => {
//     if (error.response.status) {
//       switch (error.response.status) {
//         // 401: 未登录
//         // 未登录则跳转登录页面，并携带当前页面的路径
//         // 在登录成功后返回当前页面，这一步需要在登录页操作。
//         case 401:
//           break;

//         // // 403 token过期
//         // // 登录过期对用户进行提示
//         // // 清除本地token和清空vuex中token对象
//         // // 跳转登录页面
//         // case 403:
//         //   Toast({
//         //     message: '登录过期，请重新登录',
//         //     duration: 1000,
//         //     forbidClick: true
//         //   })
//         //   // 清除token
//         //   localStorage.removeItem('token')
//         //   store.commit('loginSuccess', null)
//         //   // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
//         //   setTimeout(() => {
//         //     router.replace({
//         //       path: '/login',
//         //       query: {
//         //         redirect: router.currentRoute.fullPath
//         //       }
//         //     })
//         //   }, 1000)
//         //   break
//         //
//         // // 404请求不存在
//         // case 404:
//         //   Toast({
//         //     message: '网络请求不存在',
//         //     duration: 1500,
//         //     forbidClick: true
//         //   })
//         //   break
//         // // 其他错误，直接抛出错误提示
//         // default:
//         //   Toast({
//         //     message: error.response.data.message,
//         //     duration: 1500,
//         //     forbidClick: true
//         //   })
//       }
//       return Promise.reject(error.response);
//     }
//   }
// );
